import { v4 as uuidv4 } from 'uuid';

export function ListContextRenderer(props, childrenComponents = []) {
	return {
		componentName: 'ListContextRenderer',
		componentId: uuidv4(),
		props: Object.assign(
			{
				listElement: 'Fragment',
				itemElement: 'Fragment',
			},
			props,
		),
		childrenComponents,
	};
}
